import { APP_INITIALIZER, Injector } from "@angular/core";
import { LazyLoadService, LOADING_STRATEGY } from '@abp/ng.core';
import { concat, forkJoin } from "rxjs";

export const METRONIC_THEME_SCRIPTS_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: loadScripts,
        deps: [Injector],
        multi: true,
    },
];



export function loadScripts(injector: Injector) {
    return () => {
        const lazyLoad = injector.get(LazyLoadService);

        return forkJoin([
            // 需要预先加载的脚本
        ])
    };
}
